import { isSWSGQLError } from '@/utilities/graphQLClient';

import { sentryCaptureMessage } from '@/components/Sentry';

const KNOWN_ERROR_CODES = {
  'PRTFL-018': (symbols: string) =>
    `You cannot sell more shares than you own for ${symbols}. Please review and adjust the number of shares.`,
} as const;

export const getErrorMessage = (error: unknown) => {
  const defaultErrorMessage = `Your changes couldn't be saved. Please try again.`;

  if (!isSWSGQLError(error)) return defaultErrorMessage;

  if (error.code === 'PRTFL-018') {
    try {
      const minimumItems = 3;
      const tickerList = error.message.split('-')[1]; // Expecting message format: "... - Ticker-1, Ticker-2, ..."
      const tickers = tickerList
        .split(',')
        .map((ticker) => ticker.split(':')[1]);
      const symbolsString =
        tickers.length > minimumItems
          ? `${tickers.slice(0, minimumItems).join(', ')} and ${
              tickers.length - minimumItems
            } other ${
              tickers.length - minimumItems > 1 ? 'holdings' : 'holding'
            }`
          : tickers.join(', ');

      return KNOWN_ERROR_CODES['PRTFL-018'](symbolsString);
    } catch (_) {
      // Capture unknown errors
      sentryCaptureMessage({
        team: 'wombats',
        message: `${error.code} - ${error.message}`,
      });
      return defaultErrorMessage;
    }
  }
  // Capture unknown errors
  sentryCaptureMessage({
    team: 'wombats',
    message: `${error.code} - ${error.message}`,
  });
  return defaultErrorMessage;
};
